var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOCUSED MODE MEDIA MODALS BOOK AND ACTIVITY SIZE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4651 -2589C-4651 -2590.1 -4650.1 -2591 -4649 -2591H4746C4747.1 -2591 4748 -2590.1 4748 -2589V190C4748 191.104 4747.1 192 4746 192H-4649C-4650.1 192 -4651 191.104 -4651 190V-2589Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4649 -2590H4746V-2592H-4649V-2590ZM4747 -2589V190H4749V-2589H4747ZM4746 191H-4649V193H4746V191ZM-4650 190V-2589H-4652V190H-4650ZM-4649 191C-4649.55 191 -4650 190.552 -4650 190H-4652C-4652 191.657 -4650.66 193 -4649 193V191ZM4747 190C4747 190.552 4746.55 191 4746 191V193C4747.66 193 4749 191.657 4749 190H4747ZM4746 -2590C4746.55 -2590 4747 -2589.55 4747 -2589H4749C4749 -2590.66 4747.66 -2592 4746 -2592V-2590ZM-4649 -2592C-4650.66 -2592 -4652 -2590.66 -4652 -2589H-4650C-4650 -2589.55 -4649.55 -2590 -4649 -2590V-2592Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "student focused mode with image preview open in activity - horizontally longer",
    clipPath: "url(#clip0_6444_16538)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    transform: "translate(-828 -1069)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "activity completetion mode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_6444_16538",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-108 -989C-108 -993.418 -104.418 -997 -100 -997H900V48H-108V-989Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-108 -989C-108 -993.418 -104.418 -997 -100 -997H900V48H-108V-989Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109 -989C-109 -993.971 -104.971 -998 -100 -998H900V-996H-100C-103.866 -996 -107 -992.866 -107 -989H-109ZM900 48H-108H900ZM-109 48V-989C-109 -993.971 -104.971 -998 -100 -998V-996C-103.866 -996 -107 -992.866 -107 -989V48H-109ZM900 -997V48V-997Z",
    fill: "#9D9690",
    mask: "url(#path-3-inside-1_6444_16538)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "centerfold video view"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 570",
    x: -68,
    y: -997,
    width: 856,
    height: 1045,
    rx: 4,
    fill: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1797"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -4,
    width: 299,
    height: 32,
    rx: 4,
    fill: "#2E2E2D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 12H19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6444_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "white",
    transform: "translate(-828 -1069)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.bcb64575aa0ef4428ac17c3da2224a2b.svg";
export { ForwardRef as ReactComponent };